import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=78e8a2c6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e8a2c6')) {
      api.createRecord('78e8a2c6', component.options)
    } else {
      api.reload('78e8a2c6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=78e8a2c6", function () {
      api.rerender('78e8a2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/apps/Index.vue"
export default component.exports